import React from "react";
import WebView from "react-native-webview";
import {
  UserLoggedInNavigatorNavigationProp,
  UserLoggedInNavigatorRouteProp,
} from "../../TopLevelNavigators/UserLoggedIn/UserLoggedInNavigatorParamList";
import { Platform } from "react-native";
import { createNativeStackNavigator } from "@react-navigation/native-stack";
import { WebModal } from "../../TopLevelNavigators/UserLoggedIn/WebModal";
import { HeaderButton } from "../../components";
import { useSafeAreaInsets } from "react-native-safe-area-context";

type Props = {
  navigation: UserLoggedInNavigatorNavigationProp<"WebView">;
  route: UserLoggedInNavigatorRouteProp<"WebView">;
};

export function WebViewScreen(props: Props) {
  const insets = useSafeAreaInsets();
  return (
    <WebModal dismissable>
      <Stack.Navigator>
        <Stack.Screen
          name="WebMain"
          options={{
            headerShown: true,
            title: "",
            headerLeft:
              Platform.OS === "android"
                ? undefined
                : () => (
                    <HeaderButton
                      type="CLOSE"
                      onPress={props.navigation.goBack}
                    />
                  ),
          }}
        >
          {() =>
            Platform.OS === "web" ? (
              <iframe
                src={props.route.params.url}
                allow="clipboard-write"
                style={{ width: "100%", height: "100%" }}
              />
            ) : (
              <WebView
                allowsFullscreenVideo
                allowsInlineMediaPlayback
                source={{
                  uri: props.route.params.url,
                }}
                automaticallyAdjustContentInsets
                automaticallyAdjustsScrollIndicatorInsets
                decelerationRate={Platform.OS === "ios" ? "normal" : undefined}
                containerStyle={{
                  paddingBottom: insets.bottom,
                }}
              />
            )
          }
        </Stack.Screen>
      </Stack.Navigator>
    </WebModal>
  );
}

const Stack = createNativeStackNavigator();
